/** @file nodeFrameKey: a node's frame key from its clip track, else its default frame animation, else 0. */
import type { ClipTrack } from '@zilo/pose3d-format/types/clip';
import { frameAnimKey } from '@zilo/pose3d-pose/time/frameAnimKey';
import type { ClipTime, FrameAnimLoop } from '@zilo/pose3d-pose/time/timeTypes';

/**
 * Decision 19 + 21.2: a clip track overrides, `track.frameKey[min(floor(frame / hold), length - 1)]` on the shown clip
 * frame (clamped, not wrapped); without one the node's default frame animation at its own tick counter `ticks`
 * (`PoseParams.frameAnimTicks`, `frameAnimKey`), never derived from the clip time; else 0.
 */
export function nodeFrameKey(track: ClipTrack | undefined, anim: FrameAnimLoop | null, time: ClipTime, ticks: number): number {
  const keys = track?.frameKey;
  if (keys !== undefined && keys.length > 0) {
    const i = Math.floor(time.frame / Math.max(1, track?.hold ?? 1));
    return keys[Math.min(Math.max(0, i), keys.length - 1)] ?? 0;
  }
  return anim === null ? 0 : frameAnimKey(anim, ticks);
}
